import { FC, PropsWithChildren } from 'react';
import { GRADIENTS } from '../../config/designSystem/Colors';
import { GradientWithImage } from './GradientWithImage';
import { StyleProp, ViewStyle } from 'react-native';
import { useStores } from '../../hooks/useStores';

interface PathImageProps extends PropsWithChildren {
    id: string;
    width: number;
    height:number;
    style?: StyleProp<ViewStyle> | undefined;
}

export const PathImage : FC<PathImageProps> = ({id, children, width, height, style}) => {
  const rootStore = useStores();
  const path = rootStore?.path?.getPath(id);

  const {designSystemColor,  image}= path;
  const designSystemColorWithFallback: keyof typeof GRADIENTS.modules = designSystemColor || 'YELLOW';

  return(
    <GradientWithImage image={image} designSystemColor={designSystemColorWithFallback as string} width={width} height={height} style={style}>
      {children}
    </GradientWithImage>);
};


